import {
  transformDateToLocalDateString,
} from "helpers";
import { FleetDocumentRow } from "services/api/fleet/vehicles/documents/types";
import { ButtonMenu } from "ui/components/Button/ButtonMenu";
import ButtonMenuItem from "ui/components/Button/ButtonMenu/ButtonMenuItem";
import { PictureIcon } from "ui/components/Pictures";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

export const FLEET_VEHICLE_DOCUMENT_SEARCH_COLUMNS = (
  t: (key: string) => string,
  handleDeleteClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    id: string
  ) => void
): Column[] => {


  return [
    {
      title: "",
      key: "doc_image",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetDocumentRow) => {
        const uploads = row.childRows ?? [];

        // Bez priloga → fallback inicijal tipa dokumenta (kao na full-page searchu).
        if (uploads.length === 0) {
          return (
            <div className="w-10 h-10 rounded-full bg-gray-200 block relative">
              <span className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                {row.documentType?.name.toString().charAt(0).toUpperCase()}
              </span>
            </div>
          );
        }

        // 1+ priloga → PictureIcon u stack modu auto-razrješava ikonu iz
        // ekstenzije; klik otvara file u novom tabu; >3 prikazuje "+N" badge.
        return (
          <PictureIcon
            maxVisible={3}
            items={uploads.map((u) => ({
              id: u.id,
              url: u.url,
              fileName: u.originalFileName,
              tooltip: u.originalFileName,
            }))}
          />
        );
      },
    },
    {
      title: "admin.fleet.vehicle.document.search.name",
      key: "doc_name",
      field: "",
      type: ColumnTypes.custom,
      render: (row) => {
        return (
          <div>
            <div className="text-md">{row.name}</div>
            <div className="text-sm font-light text-slate-500">{row.documentType?.name}</div>
          </div>
        );
      },
    },
    {
      title: "admin.fleet.vehicle.document.search.createdon",
      key: "doc_created",
      field: "",
      type: ColumnTypes.custom,
      render: (row) => {
        return (
          <div className="text-md">
            {" "}
            {transformDateToLocalDateString(row.created)}
          </div>
        );
      },
    },
    {
      title: "",
      key: "doc_actions",
      alwaysVisible: true,
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetDocumentRow) => {
        return (
          <ButtonMenu
            endIcon="/media/icons/more-dots.svg"
            cssClassName="h-full"
            variant="text"
          >
            <ButtonMenuItem
              startIcon="/media/icons/trash.svg"
              variant="remove"
              onClick={(e) => handleDeleteClick(e, row.id)}
            >
              Obriši
            </ButtonMenuItem>

          </ButtonMenu>
        );
      },
    },
  ];
};




export const FLEET_VEHICLE_DOCUMENT_UPLOADS_SEARCH_COLUMNS = (
  t: (key: string) => string
): Column[] => [
    {
      title: "",
      field: "",
      type: ColumnTypes.string,
    },
    {
      title: "admin.fleet.vehicle.document.uploads.search.name",
      field: "",
      type: ColumnTypes.string,
    },
    {
      title: "",
      field: "",
      type: ColumnTypes.string,

    },
  ];
